export function formatPhoneNumber(phoneNumber: string): string {
  const cleanNumber = phoneNumber.replace(/[^0-9]/g, '');
  const length = cleanNumber.length;
  const isSeoulNumber = cleanNumber.startsWith('02');
  const areaCodeEndIndex = isSeoulNumber ? 2 : 3;

  if (cleanNumber.startsWith('1')) {
    return length <= 4 ? cleanNumber : cleanNumber.replace(/(?<no1>[0-9]{4})(?<no2>[0-9]+)/, '$1-$2');
  }
  if (length <= areaCodeEndIndex) {
    return cleanNumber;
  }
  if (length <= 4 + areaCodeEndIndex) {
    return cleanNumber.replace(new RegExp(`([0-9]{${areaCodeEndIndex}})([0-9]+)`, 'g'), '$1-$2');
  }
  const middleNumberLength = length === 7 + areaCodeEndIndex ? 3 : 4;
  return cleanNumber.replace(
    new RegExp(`([0-9]{${areaCodeEndIndex}})([0-9]{${middleNumberLength}})([0-9]+)`, 'g'),
    '$1-$2-$3',
  );
}
